<div class="center"
     dragScroll>
    @for (item of items; track $index) {
    <href [link]="item.link">
        <div class="inline-block va-t"
             [class.p-r]="$last"
             [ngClass]="$first ? 'p-l' : 'p-l-5-x p-l-5-l p-l-3-m p-l-3-s'">
            <div class="b-radius-max quick-links-item">
                @if(item.image) {
                <img class="w-12"
                     [dfImage]="item.image"
                     [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                     [ratio]="1">
                }
            </div>
            <div class="m-t-1 m-t-2-s p-b-1 center yes-wrap overflow-hidden quick-links-item"
                 [sizeClass]="'XL: p4, MS: c1'"
                 [class.line-clamp]="item.line_clamp"
                 *iCms="'text' of item">
            </div>
        </div>
    </href>
    }
</div>